<template>
  <v-container>


    <v-dialog
      v-if="templateData && editableStatus.includes(templateData.status)"
      v-model = "editTemplateMessageDialog" 
      width="500">
      <v-card class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title
          style="font-size: 28px">
          Rename Template
           <v-spacer />
           <v-icon @click="editTemplateMessageDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-template-message
            ref = "addTemplateMessage"
            :put = "templateData"
            @loading = "addButtonLoader = $event"
            @success = "handleEditInitialsSuccess">
              <label slot = "before-name" class="black--text" style="font-size: 16px">Template Name</label>
              <label slot = "before-category" class="black--text" style="font-size: 16px">Choose Category</label>
              <label slot = "before-language" class="black--text" style="font-size: 16px">Language</label>
              <label slot = "before-app" class="black--text" style="font-size: 16px">Choose WhatsApp phone number</label>
          </add-template-message>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="editTemplateMessageDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="editTemplateMessageInitials">
            Rename
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-layout row wrap class="border-radius-standard px-0 py-1 align-center" align="center">
        <v-flex v-if="templateData">
          <span class="template-title">
            {{ templateData.name }}
            <span
              :class="[
                    { 'purple--text': templateData.status === 'DRAFT' },
                    { 'red--text': templateData.status === 'REJECTED' },
                    { 'green--text': templateData.status === 'APPROVED' },
                    { 'amber--text text--darken-2': templateData.status === 'PENDING' },
              ]"
              style="text-transform: capitalize">
              ({{ templateData.status.toLowerCase() }})
              <v-icon v-if="templateData && editableStatus.includes(templateData.status)" @click="editTemplateMessageDialog = true" color="primary">edit</v-icon>
            </span>
          </span>
        </v-flex>
        <v-spacer/>
        <v-btn
          v-if="templateData && templateData.status === 'DRAFT'"
          color="black" @click="save" dark>Save for later</v-btn>
        <v-btn
          v-if="templateData && templateData.status === 'DRAFT'"
          color="primary" @click="submit">Submit</v-btn>
      </v-spacer>
    </v-layout>
    <v-layout row wrap class="white border-radius-standard pl-3 py-3">
      <v-flex xs12 lg6 class="px-0 template-msg-editor">
        <template-editor
          v-model="componentsValue"
          ref="templateEditorRef"
          :template-id="$route.params.id"
          @info="templateData = $event" />
      </v-flex>
      <v-flex xs12 lg6 class="py-5">
      	<v-layout row wrap justify-center align="center">
      		<v-flex xs12 style="display: flex; justify-content: center">
      			<template-viewer :init="componentsValue"/>
      		</v-flex>
      	</v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TemplateMessageButtons from './TemplateMessageButtons'
import TemplateViewer from './TemplateViewer'
import TemplateEditor from './TemplateEditor'
import AddTemplateMessage from '@/components/campaign-manager/template-messages-crud/AddTemplateMessage.vue'
export default {
  name: 'SingleTemplateMessage',
  components: {
  	TemplateMessageButtons,
  	TemplateViewer,
    TemplateEditor,
    AddTemplateMessage
  },
  data() {
    return {
      templateData: null,
      componentsValue: [],
      editTemplateMessageDialog: false,
      addButtonLoader: false,
      editableStatus: [ 'DRAFT']
    }
  },
  mounted() {
    
  },
  computed: {
    
  },
  methods: {
    editTemplateMessageInitials() {
      if (this.$refs.addTemplateMessage) this.$refs.addTemplateMessage.submit()
    },
    handleEditInitialsSuccess(data) {
      this.editTemplateMessageDialog = false
      // this.templateData = data
    },
  	save() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.put(`/template-message/${this.$route.params.id}/save`, { components: this.componentsValue})
      .then(()=>{
        this.$store.dispatch('setLoader', false)
      }).catch(()=>{
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    submit() {
      this.$store.dispatch('setLoader', true)
      this.$http_chat.put(`/template-message/${this.$route.params.id}/submit`, { components: this.componentsValue})
      .then((res)=>{
        this.$store.dispatch('setLoader', false)
        this.templateData = res.data.data
      }).catch((err)=>{
        this.$store.dispatch('setLoader', false)
        if(err.response.data && err.response.data.message && err.response.data.message.error && err.response.data.message.error.description) {
          this.$store.dispatch('setErrorMessage', err.response.data.message.error.description)  
        }
        else this.$store.dispatch('setErrorMessage', true)
      })
    }
  }
}
</script>

<style lang="scss">
.header-col {
}
.header-option {
  width: 100px;
  height: 100px;
  padding: 3px;
  border-radius: 8px;
  border: 1px dashed #ccc;
  background-color: #f4f5f9;
  display: block;
}
.header-content {
  width: 100px;
  margin-left: -3px;
}
.title-icon {
  .icon-holder {
    border-radius: 8px;
    padding: 3px;
  }
  .title-content {
    padding-left: 5px;
    vertical-align: super;
    font-size: 16px;
  }
}
.template-subtitle {
  font-size: 16px;
  font-weight: bold;
  padding-top: 4px;
}
.button-option {
	border: 1px solid #372fac;
	border-radius: 8px;
	padding: 10px 5px;
	width: 32.2%;
	justify-content: center;
	cursor: pointer;
	margin-left: 0px;
	margin-right: 4px;
}
.buttons-radio-gp {
	.v-input__control {
		width: 100%;
	}
}
.field-width {
	width: 450px;
}
.template-msg-editor {
	border-right: 2px dashed #f4f5f9;
}
.template-title {
  font-weight: bold;
  font-size: 22px;
}
</style>
